import { Injectable } from "@angular/core";
import { map, Observable, of } from "rxjs";
import { ToastType } from "../constants/toast-type";
import { QLEDocument } from "../models/document";
import { MyQLEAdminEventModel, MyQLEChatRequestModel, MyQLEChatResponseModel, MyQLEIDPayload, MyQLERequestCriteria, MyQLERequestModel } from "../models/qualifying-life-event";
import { ApiService } from "./api.service";
import { ToastService } from "./toast.service";
import { SessionService } from "./storage/session.service";
import { SessionStatus } from "../constants/session";


const controllerRoute = '/myqle';

@Injectable()
export class QLEService {

    public qleList: MyQLERequestModel[];
    public lifeEventOptions: MyQLEAdminEventModel;
    public dashboardQLEId: number;

    constructor(
        private apiService: ApiService,
        private toastService: ToastService,
        private sessionService: SessionService,
    ) {
        this.sessionService.$SessionClear.subscribe((status: string) => {
            switch (status) {
                case SessionStatus.clearMember:
                case SessionStatus.clearSession:
                    this.qleList = null;
                    this.lifeEventOptions = null;
                    break;
            }
        });
    }

    /**
     * 
     * @returns 
     */
    public getQleRequests(): Observable<MyQLERequestModel[]> {
        if (this.qleList)
            return of(this.qleList);

        return this.apiService.get(`${controllerRoute}`).pipe(map((response: MyQLERequestModel[]) => {
            this.qleList = response;
            return this.qleList;
        }));
    }

    public getLifeEventOptions(): Observable<MyQLEAdminEventModel> {
        if (this.lifeEventOptions)
            return of(this.lifeEventOptions);

        return this.apiService.get(`${controllerRoute}/life-event-options`).pipe(map((response: MyQLEAdminEventModel) => {
            this.lifeEventOptions = response;
            return this.lifeEventOptions;
        }));
    }

    public saveQLE(payload: MyQLERequestCriteria): Observable<MyQLERequestModel> {
        return this.apiService.post(`${controllerRoute}/save-qle-request`, payload).pipe(map((response: MyQLERequestModel) => {
            this.qleList = null;
            if (payload.id > 0)
                this.toastService.buildToastMessage(ToastType.success, 'Success', 'Request Saved');
            else
                this.toastService.buildToastMessage(ToastType.success, 'Success', 'Request Created');

            return response;
        }));
    }

    public getQLERequestByID(payload: MyQLEIDPayload): Observable<MyQLERequestModel> {
        return this.apiService.post(`${controllerRoute}/get-qle-request`, payload).pipe(map((response: MyQLERequestModel) => {
            return response;
        }));
    }

    /**
     * only returns a 204
     * @param payload 
     */
    public submitQLE(payload: MyQLEIDPayload): Observable<any> {
        return this.apiService.post(`${controllerRoute}/submit-qle-request`, payload).pipe(map(() => {
            this.qleList = null;
            this.toastService.buildToastMessage(ToastType.success, 'Success', 'Request Submitted');
            return;

        }));
    }
    /**
     * only returns a 204
     * @param payload 
     */
    public cancelQLE(payload: MyQLEIDPayload): Observable<any> {
        return this.apiService.post(`${controllerRoute}/cancel-qle-request`, payload).pipe(map(() => {
            this.qleList = null;
            return;
        }));
    }

    public getChatHistory(payload: MyQLEIDPayload): Observable<MyQLEChatResponseModel> {
        return this.apiService.post(`${controllerRoute}/chat`, payload).pipe(map((response) => {
            return response;
        }));
    }

    /**
     * only returns a 204
     * @param payload 
     */
    public saveChat(payload: MyQLEChatRequestModel): Observable<any> {
        return this.apiService.post(`${controllerRoute}/save-chat`, payload).pipe(map(() => {
            return;
        }));
    }

    public deleteDocuments(payload: MyQLEIDPayload): Observable<QLEDocument[]> {
        return this.apiService.post(`${controllerRoute}/qle-delete-documents`, payload).pipe(map((response: QLEDocument[]) => {
            this.toastService.buildToastMessage(ToastType.warning, "Document Deleted", "Document Successfully Deleted");
            return response;
        }));
    }
}